import { useCallback, useEffect } from "react";

import {
  organizationPaymentSourceSelector,
  organizationPaymentSourceLoadingSelector
} from "Reducers/organization/paymentSource/paymentSource.selectors";
import { getOrganizationPaymentSource } from "Reducers/organization/paymentSource/thunks/getOrganizationPaymentSource.thunk";
import { useAppDispatch, useAppSelector } from "Store/hooks";

export const useOrganizationPaymentSource = (organizationName: string) => {
  const dispatch = useAppDispatch();

  const paymentSource = useAppSelector(state =>
    organizationPaymentSourceSelector(state, {
      organizationId: organizationName
    })
  );

  const isLoading = useAppSelector(
    state => organizationPaymentSourceLoadingSelector(state) === true
  );

  const load = useCallback(() => {
    dispatch(
      getOrganizationPaymentSource({ organizationId: organizationName })
    );
  }, [organizationName, dispatch]);

  useEffect(() => {
    if (!paymentSource) load();
  }, [load, paymentSource]);

  return { paymentSource, load, isLoading };
};
